module.exports = __webpack_public_path__ + "24e9ce3eca58f59eab2ddc9edea072a6.svg";